export const IS_LOADING_FORM_FORGOT_PASSWORD = 'IS_LOADING_FORM_FORGOT_PASSWORD';
